import React from "react";

import PublicPromo from "./PublicPromo";

const highlightsList = [
  "Access jobs that match your specialties",
  "Real-time updates on candidate statuses",
  "Direct communications with employers",
  "Automated collections and payments",
  "Skip procurement to earn more money"
];

const videoOverlay = () => (
  <div>
    <div>
      What is RecruitiFi?
    </div>
    <div style={{ fontStyle: "italic", display: "flex", justifyContent: "center" }}>
      2m 04s
    </div>
  </div>
);

const videoAttributes = {
  src: "https://fast.wistia.com/embed/medias/8qf7o9iph8.jsonp",
  classes: "wistia_embed wistia_async_8qf7o9iph8",
  title: "Why use RecruitiFi?",
  videoOverlay: videoOverlay(),
};

function AgencyPromo({ visible }) {
  return (
    <PublicPromo
      highlightsList={highlightsList}
      videoAttributes={videoAttributes}
      visible={visible}
    />
  );
}

export default AgencyPromo;
